import React from 'react';
import StartNetworkingStep from '../../../StartNetworkingStep';
import { useScheduleEnabled } from '../../../../../../data/hooks/schedule/useScheduleEnabled';
import { useEventSchedule } from '../../../../../../data/hooks/schedule/useEventSchedule';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';

function StepViewSchedule(props) {
    const {eventId} = props,
        i18n = useI18n(),
        scheduleEnabled = useScheduleEnabled(eventId),
        hasSessions = useEventSchedule(eventId).length > 0;

    return (
        <StartNetworkingStep visible={scheduleEnabled && hasSessions} href={`/events/${eventId}/schedule`}>
            {i18n['start.view_sessions']}
        </StartNetworkingStep>
    );
}

export default StepViewSchedule;
